(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"]) return;
  try {
    
  class AnnouncementBar extends HTMLElement {
    constructor() {
      super()
      this.countdownIntervals = []
    }

    handleClick(e) {
      e.preventDefault()
      const {closeAnnouncement} = e.target.dataset
      if (closeAnnouncement === 'row') {
        e.target.closest('.announcement-bar__row').remove()
      } else {
        this.remove()
      }
    }

    connectedCallback() {
      if (this.querySelector('.announcement-bar__close')) {
        this.querySelector('.announcement-bar__close').addEventListener('click', this.handleClick.bind(this))
      }
      this.initCountdowns()
    }

    disconnectedCallback() {
      if (this.countdownIntervals) {
        this.countdownIntervals.forEach(id => clearInterval(id))
        this.countdownIntervals = []
      }
    }

    parseTargetDate(targetStr) {
      if (!targetStr) return null
      const matches = String(targetStr).trim().match(/(\d{4})[-/](\d{1,2})[-/](\d{1,2})(?:[T\s](\d{1,2}):(\d{1,2})(?::(\d{1,2}))?)?/)
      if (!matches) {
        const d = new Date(targetStr)
        return isNaN(d.getTime()) ? null : d
      }
      const year = parseInt(matches[1], 10)
      const month = parseInt(matches[2], 10) - 1
      const day = parseInt(matches[3], 10)
      const hour = matches[4] ? parseInt(matches[4], 10) : 0
      const minute = matches[5] ? parseInt(matches[5], 10) : 0
      const second = matches[6] ? parseInt(matches[6], 10) : 0
      return new Date(year, month, day, hour, minute, second)
    }

    getMadridWallClockDate() {
      try {
        const formatter = new Intl.DateTimeFormat('en-US', {
          timeZone: 'Europe/Madrid',
          year: 'numeric',
          month: 'numeric',
          day: 'numeric',
          hour: 'numeric',
          minute: 'numeric',
          second: 'numeric',
          hour12: false
        })
        const parts = {}
        formatter.formatToParts(new Date()).forEach(p => {
          if (p.type !== 'literal') parts[p.type] = parseInt(p.value, 10)
        })
        let hour = parts.hour === 24 ? 0 : (parts.hour || 0)
        return new Date(parts.year, parts.month - 1, parts.day, hour, parts.minute || 0, parts.second || 0)
      } catch(e) {
        return new Date()
      }
    }

    initCountdowns() {
      if (this.countdownIntervals) {
        this.countdownIntervals.forEach(id => clearInterval(id))
      }
      this.countdownIntervals = []

      const countdowns = this.querySelectorAll('.announcement-bar__countdown')
      countdowns.forEach(countdown => {
        const targetStr = countdown.dataset.countdownTarget
        const targetDate = this.parseTargetDate(targetStr)
        if (!targetDate) return

        const daysEl = countdown.querySelector('[data-countdown-days]')
        const hoursEl = countdown.querySelector('[data-countdown-hours]')
        const minutesEl = countdown.querySelector('[data-countdown-minutes]')
        const secondsEl = countdown.querySelector('[data-countdown-seconds]')
        const hideOnExpire = countdown.dataset.countdownHide === 'true'
        const row = countdown.closest('.announcement-bar__row')

        const updateCountdown = () => {
          const nowMadrid = this.getMadridWallClockDate()
          const distance = targetDate.getTime() - nowMadrid.getTime()

          if (distance <= 0) {
            this.updateDigits(daysEl, '00')
            this.updateDigits(hoursEl, '00')
            this.updateDigits(minutesEl, '00')
            this.updateDigits(secondsEl, '00')
            if (hideOnExpire) {
              countdown.classList.add('announcement-bar__countdown--expired')
            }
            if (row) {
              row.querySelectorAll('[data-expire-hide]').forEach(el => { el.hidden = true })
              row.querySelectorAll('[data-expire-show]').forEach(el => { el.hidden = false })
            }
            const idx = this.countdownIntervals.indexOf(intervalId)
            if (idx > -1) {
              clearInterval(intervalId)
              this.countdownIntervals.splice(idx, 1)
            }
            return
          }

          const days = Math.floor(distance / (1000 * 60 * 60 * 24))
          const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
          const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60))
          const seconds = Math.floor((distance % (1000 * 60)) / 1000)

          this.updateDigits(daysEl, String(days).padStart(2, '0'))
          this.updateDigits(hoursEl, String(hours).padStart(2, '0'))
          this.updateDigits(minutesEl, String(minutes).padStart(2, '0'))
          this.updateDigits(secondsEl, String(seconds).padStart(2, '0'))
        }

        updateCountdown()
        const intervalId = setInterval(updateCountdown, 1000)
        this.countdownIntervals.push(intervalId)
      })
    }

    updateDigits(container, value) {
      if (!container) return
      const digits = container.querySelectorAll('.countdown-digit')
      const chars = value.split('')

      while (digits.length < chars.length) {
        const span = document.createElement('span')
        span.className = 'countdown-digit'
        span.textContent = '0'
        container.appendChild(span)
      }

      const currentDigits = container.querySelectorAll('.countdown-digit')
      chars.forEach((char, i) => {
        if (i < currentDigits.length && currentDigits[i].textContent !== char) {
          const digit = currentDigits[i]
          digit.classList.remove('flip-in')
          digit.classList.add('flip-out')
          setTimeout(() => {
            digit.textContent = char
            digit.classList.remove('flip-out')
            digit.classList.add('flip-in')
            setTimeout(() => {
              digit.classList.remove('flip-in')
            }, 300)
          }, 300)
        }
      })
    }
  }

  customElements.define('announcement-bar', AnnouncementBar)

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
class FooterCollapsible extends HTMLElement {
  constructor() {
    super();

    this.details = this.querySelector('details');
    this.summary = this.querySelector('summary');
    this.summaryIsEmpty = this.summary.textContent.trim().length == 0;
		this.openDefault = this.dataset.openDefault === 'true'

    this.details.addEventListener('keyup', (event) => event.code.toUpperCase() === 'ESCAPE' && this.close());
    this.summary.addEventListener('click', this.onSummaryClick.bind(this));
    document.addEventListener('matchTablet', this.close.bind(this));
    document.addEventListener('unmatchTablet', this.open.bind(this));

    if (FoxThemeSettings.isTablet) {
			if (!this.openDefault) this.close()
    }

		document.addEventListener('matchTablet', () => {
			if (!this.openDefault) {
				this.close()
			} else {
				this.open()
			}
		})

		document.addEventListener('unmatchTablet', () => {
			this.open()
		})
		
  }

  onSummaryClick(event) {
    event.preventDefault();
    event.target.closest('details').hasAttribute('open')
      ? this.close()
      : this.open();
  }

  open() {
    this.details.setAttribute('open', true);
  }

  close() {
    !this.summaryIsEmpty && this.details.removeAttribute('open');
  }
}

customElements.define('footer-collapsible', FooterCollapsible);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["form-embajadoras"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
  const form = document.querySelector('#embajadoras-form');
  const errorMessage = document.getElementById('form-error-message');
  const requiredFields = [
    '#first-name',
    '#last-name',
    '#email',
    '#phone',
    '#channel',
    '#how-found',
    '#social-name' // 👈 Añadido como campo requerido
  ];

  // Configuración - CAMBIA ESTAS VARIABLES
  const CONFIG = {
    MAKE_WEBHOOK_URL: 'https://hook.eu2.make.com/8odpobdqmh6fps8995y48jut3ag4fdsg   ',
    MAKE_API_KEY: '64144bb2-cfc6-4bae-ae19-78178bbd4bfa',
    ENV: 'PROD' // Cambia a 'DEV' si estás probando localmente
  };

  // Inicializar validación en campos
  function initFieldValidation() {
    requiredFields.forEach(selector => {
      const field = document.querySelector(selector);
      
      // Resetear error al enfocar
      field.addEventListener('focus', () => {
        field.classList.remove('has-error');
      });
    });

    // Resetear errores en checkboxes al hacer clic
    const followersCheckbox = document.querySelector('#followers-check');
    const privacyCheckbox = document.querySelector('#privacy-check');
    
    if (followersCheckbox) {
      followersCheckbox.addEventListener('change', () => {
        followersCheckbox.classList.remove('has-error');
        errorMessage.classList.remove('active');
      });
    }
    
    if (privacyCheckbox) {
      privacyCheckbox.addEventListener('change', () => {
        privacyCheckbox.classList.remove('has-error');
        errorMessage.classList.remove('active');
      });
    }
  }

  // Validar un campo individual
  function validateField(field) {
    const value = field.value.trim();
    
    if (!value || (field.tagName === 'SELECT' && value === '')) {
      field.classList.add('has-error');
      return false;
    }
    
    // Validación específica para email
    if (field.id === 'email' && !isValidEmail(value)) {
      field.classList.add('has-error');
      return false;
    }
    
    // Validación específica para teléfono
    if (field.id === 'phone' && !isValidPhone(value)) {
      field.classList.add('has-error');
      return false;
    }
    
    return true;
  }

  // Validar email
  function isValidEmail(email) {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  }

  // Validar teléfono (mínimo 8 dígitos)
  function isValidPhone(phone) {
    const phoneRegex = /^\d{8,}$/;
    return phoneRegex.test(phone.replace(/\D/g, ''));
  }

  // Manejador de submit
  form.addEventListener('submit', async function (e) {
    e.preventDefault();
    
    // Limpiar errores previos
    document.querySelectorAll('.has-error').forEach(el => el.classList.remove('has-error'));
    errorMessage.classList.remove('active');
    
    // Validar formulario
    let isValid = true;
    requiredFields.forEach(selector => {
      const field = document.querySelector(selector);
      if (!validateField(field)) isValid = false;
    });
    
    if (!isValid) {
      errorMessage.textContent = 'Por favor revisa los campos incorrectos';
      errorMessage.classList.add('active');
      return;
    }

    // Validar checkbox de seguidores
    const followersCheckbox = document.querySelector('#followers-check');
    if (!followersCheckbox || !followersCheckbox.checked) {
      errorMessage.textContent = 'Debes confirmar que cuentas con más de 8000 seguidores';
      errorMessage.classList.add('active');
      if (followersCheckbox) {
        followersCheckbox.classList.add('has-error');
      }
      return;
    }

    // Validar checkbox de privacidad
    const consentCheckbox = document.querySelector('#privacy-check');
    if (!consentCheckbox || !consentCheckbox.checked) {
      errorMessage.textContent = 'Debes aceptar la política de privacidad';
      errorMessage.classList.add('active');
      if (consentCheckbox) {
        consentCheckbox.classList.add('has-error');
      }
      return;
    }

    // Preparar datos para enviar
    const formData = {
      firstName: document.querySelector('#first-name').value.trim(),
      lastName: document.querySelector('#last-name').value.trim(),
      email: document.querySelector('#email').value.trim(),
      phone: document.querySelector('#phone').value.trim(),
      channel: document.querySelector('#channel').value.trim(),
      howFound: document.querySelector('#how-found').value.trim(),
      socialName: document.querySelector('#social-name').value.trim(),
      meta: {
        timestamp: new Date().toISOString(),
        userAgent: navigator.userAgent,
        url: window.location.href
      }
    };

    try {
      // Enviar a Make con autenticación
      const response = await fetch(CONFIG.MAKE_WEBHOOK_URL, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-make-apikey': CONFIG.MAKE_API_KEY
        },
        body: JSON.stringify(formData),
        mode: 'cors'
      });

      console.log('Datos enviados:', formData);

      // Redirigir después del envío
      window.location.href = 'https://maminat.com/pages/gracias-formulario   ';

    } catch (error) {
      console.error('Error al enviar:', error);
      errorMessage.textContent = 'Hubo un problema al enviar el formulario.';
      errorMessage.classList.add('active');
    }
  });

  // Inicializar
  initFieldValidation();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mobile-sticky-bar"]) return;
  try {
    
  class MobileStickyBar extends HTMLElement {
    constructor() {
      super()
      document.body.classList.add('mobile-sticky-bar-enabled')
    }
  }
  customElements.define('mobile-sticky-bar', MobileStickyBar)


  } catch(e) { console.error(e); }
})();
})();
